import React             from 'react';
import servicesPricing   from 'pursuit/config/servicesPricing';
import scrollToComponent from 'react-scroll-to-component';

export default function PricingTOC(props) {
    const { scrollReferences } = props;

    return (
        <section className="pricing-toc">
            {Object.keys(servicesPricing).map((serviceType, key) => {
                return (
                    <section
                        key={key}
                        className="pricing-toc--service-type minor-margin--bottom"
                    >
                        <h3
                            className="section-title highlight"
                            dangerouslySetInnerHTML={{__html: serviceType}}
                        />
                        {Object.keys(servicesPricing[serviceType]).map((section, key) => {
                            return (
                                <section
                                    key={key}
                                    className="pricing-toc--section decent-margin--bottom"
                                >
                                    <div
                                        className="lowlight text-large bitof-margin--bottom"
                                        dangerouslySetInnerHTML={{__html: section}}
                                    />
                                    {servicesPricing[serviceType][section].map((service, key) => {
                                        return (
                                            <article
                                                key={key}
                                                onClick={() => {
                                                    scrollToComponent(
                                                        scrollReferences[service.slug], {
                                                            offset: -100,
                                                            align: 'top',
                                                            duration: 300,
                                                        }
                                                    );
                                                }}
                                                className="link bitof-margin--bottom"
                                                dangerouslySetInnerHTML={{__html: service.label}}
                                            />
                                        )
                                    })}
                                </section>
                            )
                        })}
                    </section>
                )
            })}
        </section>
    )
};
